export class OvertimeService {
    static overtimeData = null;
    static setOvertimeData(data) {
        this.overtimeData = data;
    }
    static getOvertimeData() {
        return this.overtimeData;
    }
}